import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { getUserDocumentRef } from "./util";
import { AuthActionKeyType, StatusType } from "./auth-context/reducer";
import { arrayRemove, arrayUnion, updateDoc } from "firebase/firestore";
export var setBookmarked = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(articleId, bookmarked, authContext) {
        var _authContext$, authenticated, user, userDocumentRef;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _authContext$ = authContext[0], authenticated = _authContext$.authenticated, user = _authContext$.user;
                        if (!authenticated) {
                            _context.next = 7;
                            break;
                        }
                        userDocumentRef = getUserDocumentRef(user.uid);
                        _context.next = 5;
                        return updateDoc(userDocumentRef, {
                            bookmarks: bookmarked ? arrayUnion(articleId) : arrayRemove(articleId)
                        });
                    case 5:
                        _context.next = 7;
                        return setBookmarkedContext(articleId, bookmarked, authContext);
                    case 7:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee);
    }));
    return function setBookmarked(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();
export var setBookmarkedContext = /*#__PURE__*/ function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(articleId, bookmarked, authContext) {
        var _authContext$2, authenticated, userData, dispatch, bookmarks;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _authContext$2 = authContext[0], authenticated = _authContext$2.authenticated, userData = _authContext$2.userData, dispatch = authContext[1];
                        if (authenticated && userData.status === StatusType.SUCCESS && userData.data && userData.data.bookmarks) {
                            bookmarks = bookmarked ? [].concat(_toConsumableArray(userData.data.bookmarks), [articleId]) : userData.data.bookmarks.filter(function (bookmark) {
                                return bookmark !== articleId;
                            });
                            dispatch({
                                type: AuthActionKeyType.USER_DATA_SUCCESS,
                                payload: {
                                    data: Object.assign({}, userData.data, {
                                        bookmarks: bookmarks
                                    })
                                }
                            });
                        }
                    case 2:
                    case "end":
                        return _context2.stop();
                }
            }
        }, _callee2);
    }));
    return function setBookmarkedContext(_x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
    };
}();
